import type {ReactNode} from 'react';
import {AssistantPanel, cn} from '@chekinapp/ui';

type Props = {
  name: ReactNode;
  status?: ReactNode;
  intro?: ReactNode;
  className?: string;
};

function VelaHeader({name, status, intro, className}: Props) {
  return (
    <>
      <div
        className={cn(
          'flex items-center gap-[11px] border-b border-[var(--assistant-divider)] pb-[14px]',
          className,
        )}
      >
        <AssistantPanel.Avatar />
        <div className="flex h-[38px] min-w-0 flex-col justify-between">
          <div className="text-[14px] font-bold leading-6 text-[var(--assistant-name-text)]">
            {name}
          </div>
          {status && (
            <div className="flex items-center gap-1.5 text-[12px] font-medium leading-[14px] text-[var(--assistant-status-text)]">
              {status}
            </div>
          )}
        </div>
      </div>
      {intro && (
        <p
          data-slot="vela-intro"
          className="mt-[14px] text-[13px] leading-[19px] text-[var(--assistant-intro-text)]"
        >
          {intro}
        </p>
      )}
    </>
  );
}

export {VelaHeader};
